<template>
    <div>
        <app-dialog
            v-for="item in items"
            :key="item.id"
            :app="true"
            :persistent="true"
            :hide-on-continue="true"
            v-bind="item"
            @cancel="removeItem(item)"
            @no="removeItem(item)"
            @continue="removeItem(item)"
            @input="item.value = $event"
        />
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'AppDialogQueue',
    components: {
        AppDialog: () =>
            import(
                /* webpackChunkName: "core" */
                '@/components/AppDialog'
            )
    },
    computed: {
        ...mapGetters('dialogQueue', ['items'])
    },
    methods: {
        removeItem(item) {
            this.$store.dispatch('dialogQueue/remove', item.id);
        }
    }
};
</script>
